<template>
  <DashboardLayout>
    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <p class="mb-0 main-identifier fw-semibold">Budget Management</p>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Edit Budget</p>
    </div>

    <div class="d-flex justify-content-center">
      <div class="form-outer">
        <form @submit.prevent="handleSubmit">
          <div class="crud-form position-relative">

            <div class="form-inner">
              <div class="form-header d-flex justify-content-between align-items-center">
                <h1 class="mb-0">Edit MDA Line Item Budget </h1>
              </div>

              <div class="form-body">
                <div class="row mt-2 mb-3">
                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Year</label></div>
                    <div class="col-md-9 input-right">
                      <select class="form-select" v-model="year" required>
                        <option value="" disabled>Select Year</option>
                        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label
                        for="subsector" class="form-label">M.D.A</label></div>
                    <div class="col-md-9 input-right">
                      <select class="form-select" v-model="mdaId" required>
                        <option value="">- Select MDA -</option>
                        <option v-for="r in mdas" :key="r.id" :value="r.id">
                          {{ r.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="name"
                        class="form-label">Amount Budgeted (₦)</label></div>
                    <div class="col-md-9 input-right"><input type="number" class="form-control" v-model="amountBudgeted"
                        placeholder="Enter Amount Budgeted" required></div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="name"
                        class="form-label">Amount Released (₦)</label></div>
                    <div class="col-md-9 input-right"><input type="number" class="form-control" v-model="amountReleased"
                        placeholder="Enter Amount Released" required></div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label
                        for="subsector" class="form-label">Economic Line Item</label></div>
                    <div class="col-md-9 input-right">
                      <select class="form-select" v-model="economicLineItemId" @change="checkAddNewEconomicLineItem"
                        required>
                        <option value="" disabled>- Select Economic Line Item Code -</option>
                        <option v-for="r in elis" :key="r.id" :value="r.id">
                          {{ r.description }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>


                <div class="d-flex justify-content-center ">
                  <button class="submit-btn" type="submit">Submit</button>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>
    </div>

  </DashboardLayout>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import DashboardLayout from '../layout/DashboardLayout.vue'
import Cookies from 'js-cookie';
import Swal from 'sweetalert2'

const root_api_url = process.env.VUE_APP_API_ROOT_URL



const mdaId = ref('');
const economicLineItemId = ref('');
const year = ref('');
const amountBudgeted = ref('');
const amountReleased = ref('');


const elis = ref([])
const mdas = ref([])

const isLoading = ref(false);

const currentYear = new Date().getFullYear();
const years = ref(Array.from({ length: currentYear - 2024 + 1 }, (_, i) => 2024 + i));

const fetchEconomicLineItems = async () => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/eco-line-item`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    elis.value = response.data.map(eli => ({
      id: eli.id,
      name: eli.roleName,
      description: eli.description
    }))

    // console.log(elis.value)
  } catch (error) {
    console.error('Failed to fetch roles:', error)
  }
}

const fetchMDAs = async () => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/mda`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    mdas.value = response.data.map(mda => ({
      id: mda.id,
      name: mda.name,
    }))

    // console.log(elis.value)
  } catch (error) {
    console.error('Failed to fetch roles:', error)
  }
}


const handleSubmit = async () => {

  const token = Cookies.get('auth_token');

  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

  const BudgetData = {
    mdaId: mdaId.value,
    year: year.value,
    economicLineItemId: economicLineItemId.value,
    amountBudgeted: amountBudgeted.value,
    amountReleased: amountReleased.value,
    balance: 10000,
    performance: 30,
  };

  try {
    const result = await axios.post(`${root_api_url}/eli/mda-eli-budget`, BudgetData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (result.status === 201) {
      Swal.fire({
        html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>MDA Budget Created Successfully</p> `,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
      // alert(`MDA Budget Created`)
      mdaId.value = ''
      economicLineItemId.value = ''
      amountBudgeted.value = ''
      amountReleased.value = ''
      year.value = ''
    }
  } catch (error) {
    // Swal.fire({
    //   html: `${iconHtmlError}
    //   <h1 style="font-weight:600;">Error</h1>
    //   <p>Failed to create MDA Budget</p>`,
    //   showConfirmButton: true,
    //   showCloseButton: true,
    //   icon: undefined,
    // });
    // console.error('Submission error:', err)
    // alert('Failed to create MDA: ' + (err.response?.data?.message || err.message))

    if (error.response) {
      Swal.fire({
        html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>${error?.response?.data?.errorMessage || error?.response?.data?.error || 'Unexpected error occurred while creating MDA Budget. Kindly contact administrator'}</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    } else {
      Swal.fire({
        html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>Unexpected error occurred while creating MDA Budget. Kindly contact administrator</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    }
  } finally {
    isLoading.value = false;
  }
}

onMounted(() => {
  fetchEconomicLineItems(),
  fetchMDAs(),
  document.title = "Edit MDA Line Item Budget"
})

</script>
